export default {
  aboutHero: {
    label: 'ABOUT DRA',
    title: 'DRA的理念',
  },
  philosophy: {
    label: 'THE INQUIRY',
    title: '设计必然性，\n重新定义教育',
    quote: '教育不是相信可能性的"精神论"，\n而是实现可能性的"结构提供"。',
    body1: '我们一直在质疑教育领域的"不确定性"。为什么个人的资质和努力不一定能带来持续的成果？',
    body2: '根本原因不是个人能力不足，而是个人无意识持有的"认知结构"以及重构它的"体系缺失"。',
    footer: 'DRA是一个整理思考、行动和结果链条，并将其系统化为教育的机构。',
  },
  founding: {
    label: 'CORE LOGIC',
    title: '18岁前的认知形成，\n及其之后',
    body1: '人类90%以上的决策依赖于18岁前形成的无意识认知模式（OS）。',
    body2: 'DRA客观地可视化这种内在结构，并通过基于科学视角的"DREAM CODE"支持自主重新设计（Re-structure）。',
    conclusion: '我们认为，教育不应该是相信可能性的"精神论"，\n而应该是实现可能性的"结构提供"。',
    pillar1: { label: '认知', desc: '可视化无意识结构' },
    pillar2: { label: '重新设计', desc: '基于科学视角的重构' },
    pillar3: { label: '可重现性', desc: '持续成果的系统化' },
  },
  founder: {
    label: 'FOUNDER AS AN ARCHITECT',
    title: '创始人／理事长 廣瀬進二 致辞',
    subtitle: '为什么现在需要这种结构？',
    quote: '"我们给予的不是热情，而是可重现性。"',
    description: '作为思想设计师的创始人。讲述DRA所倡导的结构化教育的本质，以及引导个人与组织实现根本性变革的设计理念。',
  },
  award: {
    label: 'GLOBAL RECOGNITION',
    title: '全球认可的\n教育框架新标准',
    intro: '2026年，纽约联合国总部。DRA所倡导的"结构化教育"的社会意义，以及引导个人与组织实现根本性变革的设计理念获得高度评价，并在国际会议上荣获大奖。这不是一时的潮流，而是作为下一代全球标准的权威认证。',
    year: '2026',
    location: '纽约',
    awardTitle: '联合国CSW70相关论坛\n荣获"Outstanding Contribution Award（卓越贡献奖）"',
    point1: '融合脑科学、行为心理学与AI的独特方法论获得高度评价',
    point2: '对女性赋权及下一代领导者培育的贡献',
    point3: '联合国ECOSOC特别协商地位团体（IDIO）的国际认证',
    note: '凭借在社会发展与教育领域的卓越贡献，DRA荣获了面向国际社会的崇高奖项。排除精神论、从认知"结构"切入的DRA创新性与实效性，已在世界最高舞台上得到充分证明。',
    buttonText: '查看获奖与活动详情',
  },
};
